<template>
    <v-app>
        <FormTab1 v-if="tab == 0"></FormTab1>
        <FormTab2 v-if="tab == 1"></FormTab2>
    </v-app>
</template>
<script>
    import FormTab1 from '@/views/Resume/FormTab1';
    import FormTab2 from '@/views/Resume/FormTab2';
    export default {
        name: "IndexResume",
        components: {
            FormTab1,
            FormTab2,
        },
        data: () => ({
            tab: null
        }),
        created() {
            this.tab = this.$route.query.tab;
        }
    }

</script>
